import React from "react";
import { Menu } from "antd";
import DropdownButton from "@/components/DropdownButton";
import ShopType from "@/enum/ShopType";
import { useModalStore } from "@/hooks/Modal/hooks";
import { usePremiumValidator, PremiumFunctionType } from "@/services/PremiumValidator";
import { MenuInfo } from "rc-menu/es/interface";
import SyncOrderByOrderTimeDialog from "../dialogs/SyncOrderByOrderTimeDialog";
import SyncOrderByOriginalIdDialog from "../dialogs/SyncOrderByOriginalIdDialog";
import ShopDTO from "@/dto/shop/ShopDTO";
import { MenuDivider, MenuItem, MenuItemGroup, SubMenu, buildMenuItems } from "@/utils/antdItems";

interface DropdownOrderSyncButtonProps {
    shop?: ShopDTO;

    syncIncrementally?(): void;
}

const DropdownOrderSyncButton: React.FC<DropdownOrderSyncButtonProps> = function (props) {
    const { shop, syncIncrementally } = props;

    const modalStore = useModalStore();

    const { validate, loading } = usePremiumValidator();

    return (
        <DropdownButton menu={{ items: [] }}
            onClick={syncIncrementally}
            trigger={["click"]}
            placement="bottomLeft"
            popupRender={() => {
                return (
                    <Menu
                        onClick={async ({ key }: MenuInfo) => {
                            // 如果是拼多多代发店铺 需要限制自动同步
                            if (shop?.type === ShopType.PDD_FDS) {
                                const shouldNext = await validate({
                                    type: PremiumFunctionType.PDD_FDS_SYNC_ORDER,
                                    shopId: shop.id,
                                });

                                if (!shouldNext) {
                                    return;
                                }
                            } else if (shop?.type === ShopType.PDD_FULFILLMENT) {
                                const shouldNext = await validate({
                                    type: PremiumFunctionType.PDD_FULFILLMENT_SYNC_ORDER,
                                    shopId: shop.id,
                                });

                                if (!shouldNext) {
                                    return;
                                }
                            }

                            if (key === "syncOrderByOrderTimeButton") {
                                modalStore.openModal(SyncOrderByOrderTimeDialog, {
                                    shopId: shop.id,
                                });
                            } else if (key === "syncOrderByOriginalIdButton") {
                                modalStore.openModal(SyncOrderByOriginalIdDialog, {
                                    shopId: shop.id,
                                });
                            }
                        }}
                     items={buildMenuItems(<>
                        <MenuItem key="syncOrderByOrderTimeButton">
                            <span>按下单时间同步订单</span>
                        </MenuItem>
                        <MenuItem key="syncOrderByOriginalIdButton">
                            <span>按订单编号同步订单</span>
                        </MenuItem>
                    </>)} />
                );
            }}
            className="ant-btn-group-success"
        >
            同步当前店铺订单
        </DropdownButton>
    );
};

export default React.memo(DropdownOrderSyncButton);
